export default __webpack_public_path__ + "static/media/LP-D2-RW.1a327535.jpg";